import React, { useRef } from "react";
import { VoteApi } from "../utils/api";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

export function VoteForm({ campaign, stand }) {

  const formRef = useRef(null);

  const { t, i18n } = useTranslation();

  const makeVote = (campaignId) => {
    const formData = new FormData(formRef.current);
    const standId = formData.get(`standId`);
    const email = formData.get('userEmail');

    if (standId === '' || standId <= 0) {
      return Swal.fire({
        icon: 'error',
        text: t('BadStandNumber'),
      });
    }

    Swal.fire({
      icon: 'question',
      text: t('AreYouSure'),
      showCancelButton: true,
      confirmButtonText: t('Vote'),
      cancelButtonText: t('Cancel'),
      reverseButtons: true
    }).then( dialog => {
      if (dialog.isConfirmed) {
        localStorage.setItem('userEmail', email);

        VoteApi.make({
          standId: Number(standId),
          email: email || null,
          campaign: campaignId,
        }).then( () => {
          Swal.fire({
            icon: 'success',
            text: t('SuccessVote')
          }).then( () => {
            const standIdInput = formRef.current.querySelector("#standId");
            if (standIdInput) {
              standIdInput.value = "";
            }
          })
        }).catch( error => {
          const errorDetails = error.response.data;

          Swal.fire({
            icon: 'error',
            text: t(`${errorDetails.message}`, `Error: ${errorDetails.message}`),
          });
        });
      }
    })
  }

  // const transLinks = {
  // 	lv: {
  // 		text: 'mūsu Privātuma politikas uzstādnēm',
  // 		link: 'https://mobilly.lv/documents/privatuma-politika/'
  // 	},
  // 	en: {
  // 		text: "Mobilly's data Privacy policy",
  // 		link: 'https://mobilly.lv/en/documents/privacy-policy/'
  // 	}
  // }

  return (
    <form ref={formRef}>
      <div className="stand-form">
        <label htmlFor="standId">{ t('StandNumber') }:</label>

        <input type="number"
               name="standId"
               minLength={1}
               step={1}
               id="standId"
               required={true}
               defaultValue={ stand || "" }
               className="stand-input"
               placeholder={ t('StandNumber') }/>

        <label htmlFor="email">{ t('Email') }:</label>

        <input type="email"
               defaultValue={ localStorage.getItem('userEmail') || null }
               name="userEmail"
               id="email"
               className="stand-input"
               placeholder={ t('Email') }/>
        <small>
          { t('Disclaimer') }
          {/*<a target="_blank" rel="noreferrer" href={transLinks[i18n.language].link}>{transLinks[i18n.language].text}</a>.*/}
        </small>

        <button type="button" className="stand-submit"
                onClick={() => makeVote(campaign.id)}>{ t('Vote') }</button>
      </div>
    </form>
  )
}
